import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { SubNavBar } from "components/common/SubNavBar";
import { useAppDispatch } from "hooks/store";
import { Typography } from "new-components/typography/Typography";
import { getApiIdentities } from "store/services/ApiIdentities/apiIdentitiesThunks";
import { handleResetApiIdentities } from "store/slices/ApiIdentities/apiIdentitiesSlice";

import { ApiTokenTableList } from "./components/ApiTokenTableList";
import { CreateApiTokenDialog } from "./components/CreateApiTokenDialog";

export function ApiTokensManagementPage() {
  const seachParams = new URLSearchParams(useLocation().search);
  const origin = seachParams.get("origin");

  const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(!!origin);

  const dispatch = useAppDispatch();

  const handleOpenCreateDialog = () => {
    setOpenCreateDialog(true);
  };

  const handleCloseCreateDialog = () => {
    setOpenCreateDialog(false);
  };

  useEffect(() => {
    // Fresh query state each visit so remount cannot show stale search/filters.
    dispatch(handleResetApiIdentities());
    dispatch(getApiIdentities());
  }, [dispatch]);

  return (
    <Box id="api-tokens-page" className="h-[calc(100vh-100px)]">
      <SubNavBar>
        <Typography variant="subtitle" textTransform="uppercase" fontWeight="semibold">
          API TOKENS
        </Typography>
      </SubNavBar>
      <Box
        className="h-[calc(100%-50px)]"
        sx={{
          px: { xs: "10px", sm: "20px", md: "30px" },
          pb: "20px",
          pt: "16px",
          boxSizing: "border-box",
          minHeight: 0,
        }}
      >
        <ApiTokenTableList onOpenCreateDialog={handleOpenCreateDialog} />
      </Box>

      {openCreateDialog && (
        <CreateApiTokenDialog isDialogOpen={openCreateDialog} onCloseDialog={handleCloseCreateDialog} />
      )}
    </Box>
  );
}
